<template>
  <v-container fluid>
    <v-row justify="center"
           class="mb-1"
           no-gutters>
      <v-col cols="11">
        <v-form ref="queryForm">
          <v-row>
            <v-col cols="2" class="py-0">
              <v-text-field prepend-inner-icon="search"
                            clearable
                            hide-details="auto"
                            @keydown.enter="queryPageReset"
                            v-model="queryRequest.outboundNum"
                            label="出库单号"/>
            </v-col>
            <v-col cols="2" class="py-0">
              <z-source-selector
                  v-model="queryRequest.aimsWarehouseId"
                  hide-details="auto"
                  multiple
                  source="WarehouseSelector"
                  label="仓库"/>
            </v-col>
            <v-col cols="2" class="py-0">
              <v-text-field prepend-inner-icon="search"
                            clearable
                            hide-details="auto"
                            @keydown.enter="queryPageReset"
                            v-model="queryRequest.relatedOrderNo"
                            label="关联工单号"/>
            </v-col>
            <v-col cols="2" class="py-0">
              <v-text-field prepend-inner-icon="search"
                            clearable
                            hide-details="auto"
                            @keydown.enter="queryPageReset"
                            v-model="queryRequest.contractNo"
                            label="合同号"/>
            </v-col>
            <v-col cols="2" class="py-0">
              <v-text-field
                  label="出库物料"
                  prepend-inner-icon="search"
                  clearable
                  hide-details="auto"
                  @keydown.enter="queryPageReset"
                  v-model="queryRequest.materialsInfo"
              />
            </v-col>
            <v-col cols="2" class="py-0">
              <v-text-field prepend-inner-icon="search"
                            clearable
                            hide-details="auto"
                            @keydown.enter="queryPageReset"
                            v-model="queryRequest.employer"
                            label="领用人"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2" class="pb-0">
              <z-select-day
                  :hide-details="'auto'"
                  label="出库"
                  :startDateRules="[]"
                  :endDateRules="[]"
                  clearable
                  v-model="queryRequest.outboundDateTime"/>
            </v-col>
            <v-col cols="2" class="pb-0">
              <z-source-selector label="去向"
                                 v-model="queryRequest.outboundDirection"
                                 source="CompanyDicSelector"
                                 multiple
                                 hide-details="auto"
                                 param="MATERIAL_DESTINATION"/>
            </v-col>
            <v-col cols="2" class="pb-0">
              <v-text-field prepend-inner-icon="search"
                            clearable
                            hide-details="auto"
                            @keydown.enter="queryPageReset"
                            v-model="queryRequest.outboundPerson"
                            label="出库操作人"/>
            </v-col>

            <v-col cols="2" class="pb-0">
              <v-text-field prepend-inner-icon="search"
                            clearable
                            hide-details="auto"
                            @keydown.enter="queryPageReset"
                            v-model="queryRequest.deptName"
                            label="科室"/>
            </v-col>
            <v-col cols="2" class="pb-0">
              <v-text-field prepend-inner-icon="search"
                            clearable
                            hide-details="auto"
                            @keydown.enter="queryPageReset"
                            v-model="queryRequest.eqpName"
                            label="设备名称"/>
            </v-col>
            <v-col cols="2" class="pb-0">
              <v-text-field prepend-inner-icon="search"
                            hide-details="auto"
                            clearable
                            @keydown.enter="queryPageReset"
                            v-model="queryRequest.eqpModel"
                            label="设备型号"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2" class="pb-0">
              <z-source-selector label="货运方式"
                                 v-model="queryRequest.freightMethod"
                                 source="DicSelector"
                                 hide-details="auto"
                                 param="DELIVERY_TYPE"/>
            </v-col>
            <v-col cols="2" class="pb-0">
              <v-text-field prepend-inner-icon="search"
                            label="发货单号"
                            hide-details="auto"
                            clearable
                            @keydown.enter="queryPageReset"
                            v-model="queryRequest.waybillNumber"/>
            </v-col>
            <v-col cols="8" class="pb-0 d-flex justify-end align-self-end">
              <v-badge
                  :content="querySelected"
                  :value="querySelected!=0"
                  color="green"
                  overlap
              >
                <v-btn small color="primary"
                       @click="queryPageReset">
                  搜索
                  <v-icon right>mdi-magnify</v-icon>
                </v-btn>
              </v-badge>
              <v-btn small color="primary" class="ml-2"
                     @click="resetQuery">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
              <v-btn color="primary" small class="ml-2"
                     @click="report">
                一键导出
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
    <v-row class="d-flex justify-center">
      <v-col :sm="11" :xs="12" cols="8">
        <v-data-table
            :headers="headers"
            :items="list"
            disable-sort
            single-expand
            show-expand
            :page.sync="queryRequest.pagedQueryInfo.index"
            :options.sync="options"
            :server-items-length="total"
            :loading="loading"
            :footer-props="footerOptions"
            :search="search">

          <template v-slot:item.materialsInfo="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{on,attrs}">
                                    <span @click="showMaterInfos(item)"
                                          class="d-inline-block text-truncate"
                                          style="cursor: pointer;color: blue;max-width: 150px;"
                                          v-bind="attrs"
                                          v-on="on">
                                         {{ item.materialsInfo }}
                                    </span>
              </template>
              <span>{{ item.materialsInfo }}</span>
            </v-tooltip>
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <div style="padding:10px 0;">
                <span>期望到账日期</span>：
                <span>{{ item.expectedDate }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>使用设备名称</span>：
                <span>{{ item.eqpName }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>使用设备品牌</span>：
                <span>{{ item.eqpBrand }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>使用设备型号</span>：
                <span>{{ item.eqpModel }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>出厂序列号</span>：
                <span>{{ item.factSerialNo }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>状态</span>：
                <span>{{ item.stateDesc }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>科室</span>：
                <span>{{ item.deptName }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>申请人</span>：
                <span>{{ item.applicant }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>申请时间</span>：
                <span>{{ item.createDateTime }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>审核人</span>：
                <span>{{ item.auditPerson }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>审核时间</span>：
                <span>{{ item.auditDate }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>运货包装</span>：
                <span>{{ item.waybillPackagingDesc }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>更新时间</span>：
                <span>{{ item.lstupdDateTime }}</span>
              </div>
              <div v-if="item.refuseReason!=null" style="padding:10px 0;">
                <span>审核建议</span>：
                <span>{{ item.refuseReason }}</span>
              </div>
            </td>

          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog v-model="exportLoading"
              fullscreen
              overlay-color="white">
      <div
          style="width: 100%;height: 100%;background-color: rgba(255,255,255,0.5);display: flex;align-items: center;justify-content: center">
        <div style="text-align: center">
          <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
          >
          </v-progress-circular>
          <br/>
          <p style="margin-top: 10px; color: blue">报表生成中,请稍等...</p>
        </div>
      </div>
    </v-dialog>

    <!--物料信息-->
    <v-dialog v-model="showMaterFlag" max-width="1200px">
      <v-card>
        <v-card-title>
          <span class="headline">编辑物料详细信息</span>
        </v-card-title>
        <v-card-text>
          <v-container class="pa-0">
            <v-form ref="auditForm">
              <v-row>
                <v-col cols="12" class="pb-0 d-flex justify-end align-self-end mb-2">
                  <v-btn v-show="currentOutRecord.returnWmsFlag" color="primary" small @click="toWarehousingMng">
                    查看退库记录
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-data-table
                    style="width: 100%;"
                    :headers="selectedMaterHeaders"
                    :items="tableMaterInfos"
                    :server-items-length="tableMaterInfos.length"
                    hide-default-footer
                    disable-sort>
                  <template v-slot:item.specification="{ item }">
                    {{
                      (item.specification ? item.specification : '') + (item.specification2 ? '-' + item.specification2 : '')
                      + (item.specification3 ? '-' + item.specification3 : '') + (item.specification4 ? '-' + item.specification4 : '')
                    }}
                  </template>
                  <template v-slot:item.returnWhseNum="{ item }">
                    {{ item.returnWhseNum == null ? '0' : item.returnWhseNum }}
<!--                    <a @click="toWarehousingMng(item.materielProdNo, item.factSerialNo, item.returnWhseNum)">-->
<!--                    -->
<!--                    </a>-->
                  </template>
                  <template v-slot:item.withdrawalFlag="{ item }">
                    <div style="align-items: center; display: flex; flex-direction: column;">
                      <v-switch :disabled="wmsMngFlag"
                                v-model="item.withdrawalFlag"
                                class=""/>
                    </div>
                  </template>

                </v-data-table>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#757575" width="100px" @click="showMaterFlag = false" dark>关闭</v-btn>
          <v-btn v-if="!wmsMngFlag" color="blue darken-1" width="100px" @click="handleUpdMaterials" dark>提交</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import {
  queryOutInfo,
  reportExport,
  updMaterialsInfo,
  queryOutboundRecordExportInfo
} from '@/api/WarehouseManagement'
import downloadReportExcel from "@/utils/reportDownLoad"
import {mapGetters} from "vuex"
import {errorNotify} from "../../utils/alertutil";
import {dataChangedCountMixin} from "@/mixin"

export default {
  name: "WarehouseOutRecord",
  mixins: [dataChangedCountMixin],
  data() {
    return {
      footerOptions: {
        itemsPerPageOptions: [10, 50, 100, 200]
      },
      //下载
      isLoading: false,
      menu1: false,
      loading: false,
      seniorQueryFlag: false,
      queryRequest: {
        returnFlag:true,
        id: "",
        pagedQueryInfo: {
          index: 1,
          pageSize: 10
        },
        companyId: "",
        outboundType: "",
        outboundNum: "",
        expectedDate: "",
        relatedOrderNo: "",
        contractNo: "",
        employer: "",
        outboundDirection: [],
        deptName: "",
        relatedMaterielProdNo: "",
        eqpName: "",
        eqpBrand: "",
        eqpModel: "",
        factSerialNo: "",
        state: "",
        applicantId: "",
        applicant: "",
        materialsInfo: "",
        auditPersonId: "",
        auditPerson: "",
        auditDate: "",
        refuseReason: "",
        outboundPersonId: "",
        outboundPerson: "",
        outboundDateTime: [],
        freightMethod: "",
        waybillNumber: "",
        waybillPackaging: "",
        createDateTime: [],
        lockedDate: '',
      },
      list: [],
      total: 0,
      options: {},
      search: '',
      headers: [
        {text: '出库单号', value: 'outboundNum', align: 'center',},
        {text: '出库类型', value: 'outboundTypeDesc', align: 'center',},
        {text: '关联工单', value: 'relatedOrderNo', align: 'center',},
        {text: '关联出厂序列号', value: 'factSerialNo', align: 'center'},
        {text: '合同号', value: 'contractNo', align: 'center',},
        {text: '关联类型', value: 'relTypeDesc', align: 'center'},
        {text: '去向', value: 'outboundDirectionDesc', align: 'center',},
        {text: '领用人', value: 'employer', align: 'center',},
        {text: '出库日期', value: 'outboundDate', align: 'center',},
        {text: '出库操作人', value: 'outboundPerson', align: 'center',},
        {text: '货运方式', value: 'freightMethod', align: 'center',},
        {text: '发货单号', value: 'waybillNumber', align: 'center',},
        {text: '出库物料', value: 'materialsInfo', align: 'center', width: 200},
        {text: '退库状态', value: 'returnStateDesc', align: 'center'},
        {
          text: "详情",
          align: 'center',
          value: "data-table-expand"
        },


      ],

      //物料信息
      exportLoading: false,
      showMaterFlag: false,
      outboundApplyId: '',
      currentOutRecord: '',
      returnWmsFlag: false,
      tableMaterInfos: [],
      selectedMaterHeaders: [
        {text: '物料产品编号', value: 'materielProdNo', align: 'center'},
        {text: '仓库', value: 'warehouseName', align: 'center'},
        {text: '库位', value: 'storageLocation', align: 'center'},
        {text: '采购申请单号', value: 'purchaseApplyNo', align: 'center',},
        {text: '物料名称', value: 'materielName', align: 'center'},
        {text: '品牌', value: 'materielBrand', align: 'center'},
        {text: '型号', value: 'materielModel', align: 'center'},
        {text: '规格', value: 'specification', align: 'center'},
        {text: '品类', value: 'category', align: 'center'},
        {text: '子类', value: 'subType', align: 'center'},
        {text: '出厂序列号', value: 'factSerialNo', align: 'center'},
        {text: '状态', value: 'stateDesc', align: 'center'},
        {text: '申请出库数量', value: 'applyNum', align: 'center', width: 100,},
        {text: '已退库数量', value: 'returnWhseNum', align: 'center', width: 100,},
        {text: '计量单位', value: 'unit', align: 'center'},
        {text: '业务标签', value: 'businessLabelDesc', align: 'center'},
        {text: '退库件标志', value: 'withdrawalFlag', align: 'center', width: 100,},
      ],
      socket: null,
      queryReportInterval: null,
      exportKey: null,
    }
  },
  watch: {
    options: {
      handler(val) {
        if (val.itemsPerPage == -1) {
          this.queryRequest.pagedQueryInfo.index = 1
          this.queryRequest.pagedQueryInfo.pageSize = 999999
        } else if (!!val.page && !!val.itemsPerPage) {
          this.queryRequest.pagedQueryInfo.index = val.page
          this.queryRequest.pagedQueryInfo.pageSize = val.itemsPerPage
        }
        this.queryPageQuery()
      },
    },
  },
  computed: {
    ...mapGetters([
      'acctId',
      'acctName',
      "wmsMngFlag",
    ]),
  },
  methods: {
    extend() {
      this.seniorQueryFlag = !this.seniorQueryFlag;
    },
    queryPageReset() {
      this.queryRequest.pagedQueryInfo.index = 1;
      this.queryPageQuery();
    },
    //分页查询
    queryPageQuery() {
      this.loading = true;
      queryOutInfo(this.queryRequest).then(res => {
        this.list = res.list;
        this.total = res.total;
        this.loading = false
      }).catch(err => {
        this.loading = false
      })
    },
    //重置
    resetQuery() {
      this.$refs.queryForm.reset();
      this.queryRequest.outboundDateTime = []
      this.queryPageQuery();
    },

    //物料信息
    showMaterInfos(item) {
      this.currentOutRecord = item;
      this.outboundApplyId = item.id;
      this.tableMaterInfos = item.materialInfoList;
      this.showMaterFlag = true;
    },

    toWarehousingMng(){
      let xtbl = this.$router.resolve({path: '/warehousing-management?relatedOutboundNo=' + this.currentOutRecord.outboundNum});
      this.$store.dispatch('setCurretTitle', '入库管理');
      window.open(xtbl.href, '_blank');
    },

    report() {
      this.exportLoading = true;
      this.isLoading = true;
      reportExport(this.queryRequest).then(res => {
        this.exportKey = res;
        this.$router.push({
          path: '/export-report-queue?id=' + res
        });
        // this.intervalTwoSeconds();
        // downloadReportExcel(res);
        // this.isLoading = false;
        // this.exportLoading = false;
      }).catch(err => {
        this.isLoading = false;
        this.exportLoading = false;
      });
    },

    //修改物料退库标志
    handleUpdMaterials() {
      let req = {
        id: this.outboundApplyId,
        materialInfoList: this.tableMaterInfos,
      }
      updMaterialsInfo(req).then(() => {
        this.showMaterFlag = false;
        this.queryPageQuery();
        this.$refs.notify.show("更新成功", {timeout: 1000, color: 'success'});
      }).catch(() => {

      });

    },

    //2s更新一次
    intervalTwoSeconds() {
      if (this.queryReportInterval) {
        clearInterval(this.queryReportInterval);
      }
      var _this = this;
      //定时任务
      _this.queryReportInterval = setInterval(() => {
        queryOutboundRecordExportInfo(this.exportKey).then(resp => {
          if (resp != null) {
            if (resp.code == '0') {
              clearInterval(_this.queryReportInterval);
              downloadReportExcel(resp.data);
              _this.isLoading = false;
              _this.exportLoading = false;
            } else if (resp.code != null) {
              clearInterval(_this.queryReportInterval);
              errorNotify(resp.msg);
              _this.isLoading = false;
              _this.exportLoading = false;
            }
          }
        }).catch(err => {
          _this.isLoading = false;
          _this.exportLoading = false;
          clearInterval(_this.queryReportInterval);
        })

      }, 2000)
    },
    // open: function () {
    //   console.log("socket连接成功")
    // },
    // error: function () {
    //   console.log("连接错误")
    // },
    getMessage: function (msg) {
      let resp = msg.data;
      if (resp.code == '0') {
        downloadReportExcel(resp.data);
      } else {
        errorNotify(resp.msg);
      }

      this.isLoading = false;
      this.exportLoading = false;
    },
    send: function () {
      this.socket.send()
    },
    close: function () {
      console.log("socket已经关闭")
    }

  },
  created() {
    const outboundNum = this.$route.query.outboundNum;
    if (outboundNum) {
      this.queryRequest.outboundNum = outboundNum
    }
    const id = this.$route.query.id;
    if (id) {
      this.queryRequest.id = id;
    }
    this.queryPageQuery();
  },
  mounted() {
    // this.initWebSocket();
  },
}
</script>

<style scoped>

</style>
